import * as React from 'react'

const Export = (props: any) => (
  <svg {...props} viewBox='0 0 14 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M14 15.411L13.9863 10L14 4.99633C14 4.82945 13.9274 4.67241 13.803 4.56442L8.79409 0.157044C8.68 0.0588957 8.52444 0 8.36889 0H0.622222C0.28 0 0 0.265031 0 0.588957V7.16564C0 7.48956 0.28 7.75459 0.622222 7.75459C0.964445 7.75459 1.24444 7.48956 1.24444 7.16564V1.17791H7.57036V5.69324C7.57036 6.01717 7.85036 6.2822 8.19258 6.2822H12.6518C12.6829 6.2822 12.7244 6.2822 12.7555 6.2724V14.8221H1.24444V12.4663C1.24444 12.1423 0.964445 11.8773 0.622222 11.8773C0.28 11.8773 0 12.1423 0 12.4663V15.411C0 15.735 0.28 16 0.622222 16H13.3778C13.72 16 14 15.735 14 15.411ZM8.8148 1.78652L12.5792 5.10432H8.8148V1.78652Z' />
  </svg>
)

export default Export



// WEBPACK FOOTER //
// ./src/components/icons/ui/Export.tsx